import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const YearGroups = combineReducers({
  fetchTeachersRequest: createRequestReducer('YEAR_GROUPS:FETCH'),
  yearGroups: createReducer(null, {
    'YEAR_GROUPS:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.year_groups
  })
})

export default YearGroups
